/**
 * ParentMessMenuCard — weekly mess menu for the child's hostel.
 * Read-only view; data from GET /api/parent/mess/{student_id}.
 */
import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";

const DAYS = ["monday", "tuesday", "wednesday", "thursday", "friday", "saturday", "sunday"];
const MEALS = ["breakfast", "lunch", "snacks", "dinner"];

const todayName = () => DAYS[(new Date().getDay() + 6) % 7];  // Monday=0

export function ParentMessMenuCard({ studentId }) {
  const [data, setData] = useState(null);
  useEffect(() => {
    api.get(`/parent/mess/${studentId}`).then((r) => setData(r.data)).catch(() => setData({ applicable: false }));
  }, [studentId]);

  if (!data || data.applicable === false) return null;
  const today = todayName();
  const todayMenu = data.menu?.[today] || {};

  return (
    <div className="vs-card p-5 lg:col-span-2" data-testid={`parent-mess-${studentId}`}>
      <div className="eyebrow mb-2">Mess menu — today ({today})</div>
      <div className="grid grid-cols-2 md:grid-cols-4 gap-3 mb-4">
        {MEALS.map((m) => (
          <div key={m} className="vs-card p-3 bg-[var(--vs-bg-subtle)]/60">
            <div className="text-[10px] uppercase font-mono tracking-widest text-[var(--vs-text-secondary)] capitalize mb-1">{m}</div>
            <div className="text-sm">{todayMenu[m] || <span className="text-[var(--vs-text-secondary)]">—</span>}</div>
          </div>
        ))}
      </div>
      <details className="text-sm">
        <summary className="cursor-pointer text-[var(--vs-secondary)] underline decoration-dotted">Show full week</summary>
        <div className="mt-3 overflow-x-auto">
          <table className="w-full text-xs">
            <thead className="bg-[var(--vs-bg-subtle)]">
              <tr>
                <th className="p-2 text-left">Day</th>
                {MEALS.map((m) => (<th key={m} className="p-2 text-left capitalize">{m}</th>))}
              </tr>
            </thead>
            <tbody>
              {DAYS.map((d) => (
                <tr key={d} className={`border-t border-[var(--vs-border)]/40 ${d === today ? "bg-amber-50/70" : ""}`}>
                  <td className="p-2 capitalize font-medium">{d}</td>
                  {MEALS.map((m) => (<td key={m} className="p-2">{data.menu?.[d]?.[m] || <span className="text-[var(--vs-text-secondary)]">—</span>}</td>))}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </details>
    </div>
  );
}
